import React, { useMemo } from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  Tooltip,
  LabelList,
} from 'recharts';
import PropTypes from 'prop-types';
import { convertGradeToNumber } from '../utils/climbing-grades';

const WallsSummary = ({ walls = [] }) => {
  const theme = useTheme();

  const gradeToNumber = (grade) => convertGradeToNumber(grade) ?? Number.NEGATIVE_INFINITY;

  const chartData = useMemo(() => {
    const counts = new Map();
    for (const wall of walls) {
      const grade = wall?.officialGrade;
      if (!grade) continue;
      const key = grade.toString().trim();
      counts.set(key, (counts.get(key) || 0) + 1);
    }
    return [...counts.entries()]
      .map(([grade, count]) => ({ grade, count, gradeNumber: gradeToNumber(grade) }))
      .filter((d) => d.gradeNumber !== Number.NEGATIVE_INFINITY)
      .sort((a, b) => a.gradeNumber - b.gradeNumber);
  }, [walls]);

  if (!chartData.length) return null;

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        bgcolor: 'transparent',
        border: 1,
        borderColor: 'divider',
        // boxShadow: 'none',
      }}
    >

      <Box sx={{ width: '100%', height: 260 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{ top: 10, right: 20, left: 10, bottom: 10 }}
          >
            
            <XAxis
              dataKey="grade"
              stroke={theme.palette.text.secondary}
              fontSize={12}
              interval={0}
            />
            {/* <YAxis
              allowDecimals={false}
              stroke={theme.palette.text.secondary}
              fontSize={12}
            /> */}

            {/* <Tooltip
              cursor={{ fill: theme.palette.action.hover }}
              contentStyle={{
                background: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
              }}
              labelStyle={{ color: theme.palette.text.primary }}
            /> */}
            <Bar dataKey="count" fill={theme.palette.primary.main} radius={[6, 6, 0, 0]}>
              <LabelList
                dataKey="count"
                position="top"
                fill={theme.palette.text.primary}
                fontSize={12}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default WallsSummary;

WallsSummary.propTypes = {
  walls: PropTypes.array,
};
